
import { mapState } from 'vuex'
export default {
  name: 'FooterCommon',
  // eslint-disable-next-line vue/require-prop-types
  props: ['listMenu'],
  data() {
    return {
      listMenuLeft: [
        {
          key: 'introduction',
          title: this.$t('home.footer.introduction'),
          link: '/gioi-thieu',
          rel: 'nofollow'
        },
        {
          key: 'contact_customer',
          title: this.$t('home.footer.contact_customer'),
          link: '/chinh-sach-ban-hang',
          rel: 'nofollow'
        },
        {
          key: 'privacy',
          title: this.$t('home.footer.privacy'),
          link: '/dieu-khoan-su-dung-chinh-sach-bao-mat',
          rel: 'nofollow'
        },
        {
          key: 'store',
          title: this.$t('home.footer.store'),
          link: '/ban-hang-doanh-nghiep',
          rel: 'nofollow'
        },
        {
          key: 'contact',
          title: this.$t('home.footer.contact'),
          link: '/thong-tin-lien-he',
          rel: 'nofollow'
        },
        {
          key: 'shipping_policy',
          title: this.$t('home.footer.shipping_policy'),
          link: '/chinh-sach-van-chuyen-giao-nhan',
          rel: 'nofollow'
        },
        {
          key: 'warranty_policy',
          title: this.$t('home.footer.warranty_policy'),
          link: '/chinh-sach-bao-hanh',
          rel: 'nofollow'
        },
        {
          key: 'payment_policy',
          title: this.$t('home.footer.payment_policy'),
          link: '/chinh-sach-thanh-toan',
          rel: 'nofollow'
        },
        {
          key: 'checking_policy',
          title: this.$t('home.footer.checking_policy'),
          link: '/chinh-sach-kiem-hang',
          rel: 'nofollow'
        },
        {
          key: 'rules_business',
          title: this.$t('home.footer.rules_business'),
          link: '/quy-dinh-mua-ban',
          rel: 'nofollow'
        },
        {
          key: 'info_protection',
          title: this.$t('home.footer.info_protection'),
          link: '/chinh-sach-bao-ve',
          rel: 'nofollow'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      setting: state => state.setting
    })
  }
}
